export default __webpack_public_path__ + "static/media/White-commentFocus.67deee10.svg";